export default function Stats({ children }) {
  const keys = Object.keys(children);

  return (
    <div className="py-3 md:py-6 grid gap-6 md:flex md:items-start md:justify-center md:-mx-6 w-full font-sans">
      {keys.map((key, index) => (
        <div
          className="md:w-1/3 md:px-6 flex flex-col items-center whitespace-normal text-center"
          key={index}
        >
          <strong className="text-cornflower text-3xl md:text-6xl font-bold mr-3 md:mr-0">
            {key}
          </strong>
          <p className="text-haiti leading-loose font-bold text-lg">
            {children[key]}
          </p>
        </div>
      ))}
    </div>
  );
}
